<template>
  <v-container
    grid-list-xs
    class="d-flex flex-column justify-center align-center register-section py-16 fill-height"
  >
    <v-card class="card" :class="!currentWave ? 'card-wrapper' : ''">
      <div v-if="currentWave">
        <v-card-title
          primary-title
          class="dark-blue white--text title font-weight-medium login-title px-10 card-border"
          >Daftar</v-card-title
        >

        <v-container grid-list-xs class="card-body pt-0">
          <v-form class="form" ref="form" @submit.prevent>
            <v-text-field
              label="Nama Lengkap"
              class="mt-10"
              v-model="name"
              :rules="[(v) => !!v || 'Mohon isi nama lengkap']"
              filled
              @keyup.enter.native="register"
            >
              <template v-slot:prepend-inner>
                <v-icon class="mx-2">mdi-account-outline</v-icon>
              </template>
            </v-text-field>

            <v-text-field
              label="Email"
              v-model="username"
              :rules="emailRules"
              filled
              @keyup.enter.native="register"
            >
              <template v-slot:prepend-inner>
                <v-icon class="mx-2">mdi-email-outline</v-icon>
              </template>
            </v-text-field>

            <v-text-field
              label="Password"
              v-model="password"
              :rules="passwordRules"
              filled
              :type="show1 ? 'text' : 'password'"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="show1 = !show1"
              @keyup.enter.native="register"
            >
              <template v-slot:prepend-inner>
                <v-icon class="mx-2">mdi-lock-outline</v-icon>
              </template>
            </v-text-field>

            <v-text-field
              label="Konfirmasi Password"
              v-model="confirmPassword"
              filled
              :rules="confirmationPasswordRules"
              :type="show2 ? 'text' : 'password'"
              :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="show2 = !show2"
              @keyup.enter.native="register"
            >
              <template v-slot:prepend-inner>
                <v-icon class="mx-2">mdi-lock-outline</v-icon>
              </template>
            </v-text-field>

            <center>
              <p v-if="error" class="red--text caption">{{ error }}</p>
              <div id="recaptcha">
                <VueSimpleRecaptcha
                  sitekey="6Ldzu6UoAAAAAE7c8kKAlGsbX49zOe3SsfTOA5pN"
                  ref="recaptcha"
                  @callback="callback"
                />
              </div>
              <v-btn
                color="dark-blue white--text btn-auth mt-5"
                @click="register"
                >Daftar</v-btn
              >
              <p class="pt-5 subtitle-1 font-weight-normal">
                Sudah punya akun?
                <router-link
                  to="/masuk"
                  class="text-decoration-none accentDarkBlue--text font-weight-bold"
                  >Masuk</router-link
                >
              </p>
            </center>
          </v-form>
        </v-container>
      </div>
      <div v-if="!currentWave" class="pa-5">
        <v-container grid-list-xs py-5>
          <center>
            <p>Pendaftaran akun masih ditutup</p>
          </center>
        </v-container>
      </div>
    </v-card>
  </v-container>
</template>


<script>
import axios from "axios";
import { EventBus } from "../event-bus";
import moment from "moment";
import VueSimpleRecaptcha from "vue-simple-recaptcha";

export default {
  components: {
    VueSimpleRecaptcha,
  },
  data: () => ({
    name: "",
    handphone: "",
    username: "",
    password: "",
    confirmPassword: "",
    error: "",
    currentWave: "",
    date: "",
    show1: false,
    token: "",
    show2: false,
    emailRules: [
      (v) => !!v || "Mohon isi email",
      (v) => /.+@.+\..+/.test(v) || "Email tidak valid",
    ],

    handphoneRules: [
      (v) => !!v || "Mohon isi nomor WhatsApp Aktif",
      (v) =>
        /^[0-9]+$/.test(v) ||
        "Nomor handphone harus berupa angka dan tanpa spasi",
    ],
    usernameRules: [
      (v) => !!v || "Mohon isi username",
      (v) =>
        /^[a-z0-9_@.]+$/.test(v) ||
        "Username hanya boleh mengandung huruf kecil, angka, dan beberapa karakter seperti email",
      (v) => (v && v.length >= 6) || "Username harus lebih dari 6 karakter",
    ],
    passwordRules: [
      (v) => !!v || "Mohon isi password",
      (v) => (v && v.length >= 6) || "Password harus lebih dari 6 karakter",
    ],
  }),

  computed: {
    confirmationPasswordRules() {
      return [
        () =>
          this.password === this.confirmPassword ||
          "Konfirmasi password harus sama dengan password",
        (v) => !!v || "Mohon isi konfirmasi password",
      ];
    },
  },

  mounted() {
    this.checkWave();
  },

  methods: {
    callback(token) {
      this.$refs.recaptcha["g-recaptcha-response"] = token;
      this.$refs.form["g-recaptcha-response"] = token;
      this.token = token;
      if (this.token) {
        document.getElementById("recaptcha").hidden = true;
        EventBus.$emit("showSnackbar", "Recaptcha berhasil", "green");
      }
    },
    checkWave() {
      moment.locale("id");

      const currentTime = moment(localStorage.getItem("date"));
      this.date = currentTime;

      const currentWave = this.$date.filter((itemDate) => {
        const range = moment().range(
          moment(itemDate.open),
          moment(itemDate.close)
        );
        return range.contains(currentTime);
      });

      if (currentWave.length > 0) this.currentWave = currentWave;
      else this.currentWave = "";
    },
    async register() {
      if (this.$refs.form.validate()) {
        EventBus.$emit("startLoading");
        axios
          .post(`${this.$api}/register`, {
            "g-recaptcha-response": this.token,
            nama: this.name,
            // no_hp: this.handphone,
            username: this.username,
            email: this.username,
            role: 1,
            password: this.password,
          })
          .then((response) => {
            if (response.data.STATUS == "ERROR") {
              EventBus.$emit("stopLoading");
              this.error = response.data.MESSAGE;
            } else {
              localStorage.setItem(
                "token",
                response.data.PAYLOAD.u_login_token
              );
              localStorage.setItem("id", response.data.PAYLOAD.u_id);
              localStorage.setItem(
                "username",
                response.data.PAYLOAD.u_username
              );

              EventBus.$emit("triggerCheckLoginToken");
              EventBus.$emit("stopLoading");

              this.$router.push({ name: "home" });
            }
          });
      }
    },
  },
};
</script>



<style scoped>
.card {
  border-radius: 10px !important;
}

.card-border {
  border-top-left-radius: 10px !important;
  border-top-right-radius: 10px !important;
}

.btn-auth {
  width: 100% !important;
  border-radius: 10px !important;
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
  font-size: 1rem;
  letter-spacing: 0.15rem;
}
.dark-blue {
  background-color: #24305e !important;
}

.card-wrapper {
  margin: 100px 0;
  width: 70%;
}

.register-section {
  min-height: 90vh;
}

.register-title {
  font-family: "Montserrat", sans-serif !important;
}

.card-body {
  padding: 30px;
}

.form {
  width: 450px;
}

@media screen and (max-width: 600px) {
  .form {
    width: 400px;
  }
}

@media screen and (max-width: 450px) {
  .register-section {
    height: 110vh;
  }

  .card {
    width: 90%;
  }

  .form {
    width: 100%;
    margin: 0 auto;
  }
}

@media screen and (max-width: 500px) {
  .card-wrapper {
    width: 80%;
  }
}
</style>